<template>
  <div
    class="bg-grays-lighter border-grays-light flex flex-col rounded-lg border px-6 py-7"
  >
    <h2 class="text-grays-darkest text-xl font-medium tracking-wide">
      Have a question?
    </h2>
    <div class="text-teal-primary mt-4 flex flex-col space-y-1 font-semibold">
      <a
        href="mailto:redemption.support@zennioptical.com"
        class="flex items-center space-x-2"
      >
        <ZenniIconsIconMail size="sm" />
        <span>Email</span>
      </a>
    </div>
  </div>
</template>
